import { useEffect, useState } from 'react'
import { AlertCircle, X } from 'lucide-react'

interface ErrorModalProps {
    isOpen: boolean
    onClose: () => void
    title?: string
    message?: string
    autoClose?: boolean
    autoCloseDelay?: number
}

export function ErrorModal({
    isOpen,
    onClose,
    title = 'Erro!',
    message = 'Ocorreu um erro ao processar a solicitação.',
    autoClose = false,
    autoCloseDelay = 5000
}: ErrorModalProps) {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (isOpen) {
            // Animação de entrada
            setTimeout(() => setIsVisible(true), 10)
            
            // Auto-fechar se habilitado
            if (autoClose) {
                const timer = setTimeout(() => {
                    setIsVisible(false)
                    setTimeout(() => onClose(), 300) // Aguarda animação de saída
                }, autoCloseDelay)
                return () => clearTimeout(timer)
            }
        } else {
            setIsVisible(false)
        }
    }, [isOpen, autoClose, autoCloseDelay, onClose])

    if (!isOpen) return null

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
            <div
                className={`
                    bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden
                    transition-all duration-300 ease-out
                    ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}
                `}
            >
                {/* Header com gradiente vermelho */}
                <div className="bg-gradient-to-r from-red-400 via-red-500 to-red-600 p-6 text-center relative">
                    <button
                        onClick={() => {
                            setIsVisible(false)
                            setTimeout(() => onClose(), 300)
                        }}
                        className="absolute top-4 right-4 text-white hover:text-red-200 transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    <div className="flex justify-center mb-4">
                        <div className="bg-white bg-opacity-20 rounded-full p-4">
                            <AlertCircle className="h-12 w-12 text-white" />
                        </div>
                    </div>

                    <h2 className="text-2xl font-bold text-white mb-2">
                        {title}
                    </h2>
                </div>

                {/* Conteúdo */}
                <div className="p-6 text-center">
                    <p className="text-gray-600 dark:text-gray-300 text-lg mb-6">
                        {message}
                    </p>

                    <button
                        onClick={() => {
                            setIsVisible(false)
                            setTimeout(() => onClose(), 300)
                        }}
                        className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    )
}

